import { useState } from 'react';
import { useAuth } from '../contexts/auth-context';
import { Button, Card, Field, FIELD_CONTROL, PageHeader } from './ui';
import AccountStatus from './AccountStatus';

// Pagina op /reset-password?token=… — nieuw wachtwoord instellen via een reset-link.
export default function ResetPasswordView() {
  const { resetPassword } = useAuth();
  const token = new URLSearchParams(window.location.search).get('token') || '';

  const [password, setPassword] = useState('');
  const [confirm, setConfirm]   = useState('');
  const [busy, setBusy]         = useState(false);
  const [error, setError]       = useState(null);
  const [done, setDone]         = useState(false);

  async function submit(e) {
    e.preventDefault();
    setError(null);
    if (password.length < 8) { setError('Wachtwoord moet minstens 8 tekens zijn'); return; }
    if (password !== confirm) { setError('Wachtwoorden komen niet overeen'); return; }
    setBusy(true);
    try {
      const { ok, error } = await resetPassword(token, password);
      if (ok) setDone(true);
      else setError(error || 'Wachtwoord wijzigen mislukt. Vraag zo nodig een nieuwe reset-link aan.');
    } catch { setError('Geen verbinding. Je wachtwoord kon niet worden gewijzigd. Probeer opnieuw.'); }
    finally { setBusy(false); }
  }

  function goHome() { window.history.pushState({}, '', '/'); window.location.reload(); }

  return (
    <div className="flex items-center justify-center min-h-[400px] p-4">
      <Card className="w-full max-w-md">
        <div className="flex flex-col gap-4">
        <PageHeader title="Nieuw wachtwoord instellen" sub="Kies een nieuw wachtwoord om weer veilig bij je ritten te kunnen." />

        {!token && <AccountStatus error={'Geen geldige reset-link. Vraag een nieuwe aan via "Wachtwoord vergeten".'} />}

        {done ? (
          <>
            <AccountStatus>Je wachtwoord is gewijzigd en je bent ingelogd.</AccountStatus>
            <Button variant="accent" onClick={goHome}>Naar het dashboard</Button>
          </>
        ) : token ? (
          <form onSubmit={submit} className="flex flex-col gap-3">
            <Field label="Nieuw wachtwoord" hint="Minstens 8 tekens.">
              {props => <input {...props} type="password" required minLength={8} value={password}
                onChange={e => setPassword(e.target.value)} className={FIELD_CONTROL}
                placeholder="Minstens 8 tekens" autoComplete="new-password" autoFocus />}
            </Field>
            <Field label="Herhaal wachtwoord">
              {props => <input {...props} type="password" required minLength={8} value={confirm}
                onChange={e => setConfirm(e.target.value)} className={FIELD_CONTROL}
                placeholder="Herhaal" autoComplete="new-password" />}
            </Field>
            <AccountStatus error={error} />
            <Button variant="accent" type="submit" disabled={busy}>
              {busy ? 'Bezig…' : 'Wachtwoord opslaan'}
            </Button>
          </form>
        ) : null}
        </div>
      </Card>
    </div>
  );
}
